<template>
  <tab-item-template>
    <template #toolbar-items>
      <el-tooltip content="新規" placement="bottom">
        <v-btn icon @click="openCreateDialog">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </el-tooltip>
      <v-spacer></v-spacer>
      <v-text-field
          v-model="filterText"
          clearable
          outlined
          dense
          placeholder="検索"
          light
          background-color="white"
          style="max-width: 300px;"
          hide-details>
      </v-text-field>
    </template>

    <el-table :data="contractProfileTemplateView">
      <el-table-column
          label="テンプレート名"
          prop="name">
      </el-table-column>
      <el-table-column
          label="説明"
          prop="description">
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.description"
                placeholder="未設定"
                multi-line>
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>
      <el-table-column
          width="93"
          align="right"
          fixed="right">
        <template #default="{row}">
          <icon-btns>
            <icon-btn
                type="delete"
                @click="openDeleteDialog(row)">
            </icon-btn>
            <icon-btn
                type="edit"
                :to="{name: '/profileManagement/contractProfileTemplate', params: {contractProfileTemplateId: row.id}}">
            </icon-btn>
          </icon-btns>
        </template>
      </el-table-column>
    </el-table>

    <simple-dialog
        :value="createDialog"
        title-text="契約テンプレート作成"
        @close="closeCreateDialog">
      <v-row>
        <v-col>
          <v-text-field
              v-model="createDialog.name"
              label="テンプレート名"
              :rules="[v => !!v || 'テンプレート名を入力してください']"
              autofocus>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-textarea
              v-model="createDialog.description"
              label="説明"
              messages="複数行入力可"
              rows="1"
              auto-grow>
          </v-textarea>
        </v-col>
      </v-row>
    </simple-dialog>

    <simple-dialog
        :value="deleteDialog"
        title-text="契約テンプレート削除"
        title-color="delete"
        apply-text="削除"
        header-text="以下の契約テンプレートを削除します。本当によろしいですか？"
        @close="closeDeleteDialog">
      <v-row>
        <v-col>
          <text-field-like
              v-model="deleteDialog.name"
              label="テンプレート名">
          </text-field-like>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <text-field-like
              v-model="deleteDialog.description"
              label="説明"
              multi-line
              hide-details>
          </text-field-like>
        </v-col>
      </v-row>
    </simple-dialog>
  </tab-item-template>
</template>

<script>
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import IconBtns from "@/components/molecules/IconBtns";
import IconBtn from "@/components/molecules/IconBtn.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
export default {
  name: "ContractProfileTemplateTab",
  components: {TextFieldLike, TableInline, IconBtn, IconBtns, SimpleDialog, TabItemTemplate},
  props: {
    contractProfileTemplates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      createDialog: false,
      deleteDialog: false,
      filterText: '',
    };
  },
  computed: {
    ...mapGetters({
      account: 'account'
    }),
    contractProfileTemplateView() {
      const f = this.filterText;
      if(f) {
        return this.contractProfileTemplates.filter(dp =>
            dp.name.includes(f) ||
            dp.description?.includes(f)
        );
      } else {
        return this.contractProfileTemplates;
      }
    }
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar'
    }),
    ...mapActions({
      createContractProfileTemplate: 'hcs/contractProfileTemplate/create',
      deleteContractProfileTemplate: 'hcs/contractProfileTemplate/delete',
    }),
    openCreateDialog() {
      this.createDialog = {};
    },
    closeCreateDialog(apply) {
      if(apply) {
        this.showSnackbar({
          message: '契約テンプレートを作成中...',
          timeout: false,
          loading: true
        });
        this.createContractProfileTemplate({
          ...this.createDialog,
          terminalId: this.account.user.terminalId
        }).then(() => {
          this.showSnackbar({
            message: '契約テンプレートを作成しました',
          });
        }, () => {
          this.showSnackbar({
            color: 'failed',
            message: '契約テンプレートの作成に失敗しました',
          });
        });
      }
      this.createDialog = false;
    },
    openDeleteDialog(row) {
      this.deleteDialog = row;
    },
    closeDeleteDialog(apply) {
      if(apply) {
        this.showSnackbar({
          message: '契約テンプレートを削除中...',
          timeout: false,
          loading: true
        });
        this.deleteContractProfileTemplate(this.deleteDialog.id).then(() => {
          this.showSnackbar({
            message: '契約テンプレートを削除しました',
          });
        }, () => {
          this.showSnackbar({
            color: 'failed',
            message: '契約テンプレートの削除に失敗しました',
          });
        });
      }
      this.deleteDialog = false;
    }
  }
}
</script>

<style scoped>

</style>
